const cancelationReasons = ['Past Effective Date', 'Coverage', 'Pricing', 'Loyalty'];

export const cancelationReasonsExternalUser = cancelationReasons.concat('Other');
export const cancelationReasonsInternalUser = cancelationReasons.concat('Duplicate', 'Other');

export const carriers = [
  'AIG',
  'American Family Insurance',
  'Amtrust',
  'Arbella Insurance',
  'Arden',
  'Auto-Owners Insurance',
  'CAU',
  'CIBA',
  'Cincinnati Insurance',
  'CNA',
  'CondoLogic',
  'Deans & Homer',
  'Donegal',
  'Dongbu Insurance',
  'Erie Insurance',
  'Farmers Insurance',
  'GNY',
  'Grange Insurance',
  'Great American',
  'Hanover',
  'The Hartford',
  'Harford Mutual Insurance Group',
  'Hippo',
  'HoneyComb',
  'Ian H. Graham Insurance',
  'IHG',
  'Main Street America',
  'McGowan Program Administrators',
  'Med James Specialty',
  'Mercury Insurance',
  'MiddleOak',
  'Millers Mutual',
  'Nationwide',
  'The Norfolk & Dedham Group',
  'Philadelphia Insurance',
  'Rockingham',
  'State Auto',
  'State Farm',
  'Strata',
  'Tower Hill',
  'Travelers',
  'UCA General',
  'UFG Insurance',
  'Other',
  'No Prior Coverage',
  'Unknown',
];

export const duplicateQuoteSource = ['Same Broker', 'Different Broker'];
